webpackJsonp([40349708705702],{

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(655);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleLink = function (_React$Component) {
	  _inherits(SimpleLink, _React$Component);
	
	  function SimpleLink() {
	    _classCallCheck(this, SimpleLink);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SimpleLink.prototype.render = function render() {
	    var _props = this.props,
	        title = _props.title,
	        text = _props.text,
	        url = _props.url,
	        target = _props.target,
	        children = _props.children,
	        className = _props.className,
	        rel = _props.rel;
	
	
	    return _react2.default.createElement(
	      'a',
	      {
	        className: 'simple-link ' + className,
	        href: url,
	        target: target,
	        rel: rel,
	        title: title || text
	      },
	      text,
	      children
	    );
	  };
	
	  return SimpleLink;
	}(_react2.default.Component);
	
	SimpleLink.propTypes = {
	  title: _react.PropTypes.string,
	  text: _react.PropTypes.string,
	  url: _react.PropTypes.string,
	  target: _react.PropTypes.string,
	  children: _react.PropTypes.any,
	  className: _react.PropTypes.any,
	  rel: _react.PropTypes.string
	};
	SimpleLink.defaultProps = {
	  target: '_blank',
	  rel: 'noopener noreferrer',
	  className: ''
	};
	exports.default = SimpleLink;
	module.exports = exports['default'];

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(662);
	
	var _SimpleLink = __webpack_require__(257);
	
	var _SimpleLink2 = _interopRequireDefault(_SimpleLink);
	
	var _ga = __webpack_require__(10);
	
	var _wixEngineering = __webpack_require__(774);
	
	var _wixEngineering2 = _interopRequireDefault(_wixEngineering);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiversityTicketsPage = function (_React$Component) {
	  _inherits(DiversityTicketsPage, _React$Component);
	
	  function DiversityTicketsPage() {
	    _classCallCheck(this, DiversityTicketsPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DiversityTicketsPage.prototype.componentWillMount = function componentWillMount() {
	    (0, _ga.gaTrack)({
	      eventCategory: 'diversity',
	      eventAction: 'diversity',
	      eventLabel: 'Diversity'
	    });
	  };
	
	  DiversityTicketsPage.prototype.render = function render() {
	    var TEXT_EMAIL = 'diversity@yglf.com.ua';
	    var URL_EMAIL = 'mailto:' + TEXT_EMAIL;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'page-diversity-tickets lines-bg' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container container-fluid' },
	        _react2.default.createElement(
	          _SimpleLink2.default,
	          {
	            url: 'https://www.wix.engineering/',
	            className: 'link-wix-logo'
	          },
	          _react2.default.createElement('img', {
	            className: 'wix-engineering-logo',
	            src: _wixEngineering2.default,
	            alt: 'WIX Engineering'
	          })
	        ),
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Diversity Tickets'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We are proud to announce that we have Diversity tickets for YGLF Conference!'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'What are Diversity tickets'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'They are a kind of tickets, made especially for people that are lacking stable representation in the tech industry.'
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'How to apply'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Submission has closed on January 15, 2018.',
	            _react2.default.createElement('br', null),
	            'We had a sweepstake sponsored by Wix Engineering for discounted diversity tickets at $50 per ticket.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'After submission 40 lucky people were randomly selected and contacted through the e-mail address which they had submitted.'
	          )
	        )
	      )
	    );
	  };
	
	  return DiversityTicketsPage;
	}(_react2.default.Component);
	
	exports.default = DiversityTicketsPage;
	module.exports = exports['default'];

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wix-engineering.feee28e5.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-diversity-js-7547835215b0c13f4f55.js